/**
 * Helpers: Validators
 *
 * File builds object with allowed validators from
 * vuelidator. It is used for validating inputs.
 *
 * Extending:
 * a) `alpha` - Add space to allowed chars
 *
 * @see https://vuelidate.netlify.com/#sub-regex-based-validator
 * @author PH
 */
import axios from 'axios';
import { has } from 'lodash';
import { helpers } from 'vuelidate/lib/validators';
import { required, email, alpha, url, minLength } from 'vuelidate/lib/validators';

const Validators = {
  required: required,
  email: email,
  alpha: helpers.regex('alpha', /^[a-zA-Z\ ]*$/),
  url: url,
  minLength: minLength,

  /**
   * Validate field value with API. The field object needs to have
   * the API data set in the settings.
   *
   * @see https://vuelidate.netlify.com/#sub-asynchronous-validation
   * @author PH
   * @return {bool}
   */
  async api(value, component) {
    if (has(component.settings, 'validation.api')) {
      try {
        const result = await axios.get(component.settings.validation.api.url + value);

        if (result.data) {
          component.setValidationResponse(result.data);
        }

        return true;
      } catch (error) {
        if (error.response.data.cause) {
          alert(error.response.data.cause)
        }

        return false;
      }
    }

    return true;
  }
};

export default Validators;
